/* import __COLOCATED_TEMPLATE__ from './write-a-check.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { assertInstanceOf } from '@banking/ui/utils/assert';
import { inject as service } from '@ember/service';
import { get as getFromLocalStorage } from '@square/dashboard-utilities/utils/persistable';
import { HIDE_CHECK_EDUCATION_LOCAL_STORAGE_KEY } from '@banking/ui/workflows/balance/update';
let CreatePrintableCheckWrite = (_class = class CreatePrintableCheckWrite extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "logEvents", _descriptor, this);
    this.logEvents.track(this.args.writeCheckConfiguration?.logEvents?.viewLogEvent);
  }
  get isCheckEducationHidden() {
    return getFromLocalStorage(HIDE_CHECK_EDUCATION_LOCAL_STORAGE_KEY);
  }
  get currencySymbol() {
    return '$';
  }
  get memoPreviewText() {
    if (this.args.writeCheckConfiguration?.memoInput?.description?.label) {
      return this.args.writeCheckConfiguration.memoInput.description.label.split(' ')[1];
    }
    return '';
  }
  get imgSrc() {
    if (this.args.writeCheckConfiguration.preview?.rendered) {
      const {
        mimeType,
        imageBytes
      } = this.args.writeCheckConfiguration.preview.rendered;
      return `data:${mimeType};base64,${imageBytes}`;
    } else {
      return '';
    }
  }
  onIconClicked() {
    this.args.onShowEducation();
  }
  onAmountChange(money) {
    this.args.updateCreatePrintableCheckRequest('amount', money);
  }
  onInputChange(field, event) {
    const value = assertInstanceOf(event, CustomEvent).detail.value;
    this.args.updateCreatePrintableCheckRequest(field, value);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "logEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onIconClicked", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onIconClicked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onAmountChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onAmountChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInputChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInputChange"), _class.prototype)), _class);
export { CreatePrintableCheckWrite as default };